<app-side-menu>
  <div class="external-providers-view-container">
    <!-- Loading State -->
    <app-loading [show]="isLoading" message="Carregando prestador..."></app-loading>

    <!-- Content -->
    <div *ngIf="!isLoading && provider" class="view-content">
      <!-- Header -->
      <div class="header">
        <div class="title-section">
          <h1>
            <i class="fas fa-handshake me-2"></i>
            {{ provider.tradeName || provider.companyName || 'Prestador de Serviço Externo' }}
          </h1>
          <p *ngIf="provider.companyName && provider.companyName !== provider.tradeName">
            {{ provider.companyName }}
          </p>
        </div>
        <div class="action-buttons">
          <button class="btn btn-primary" (click)="navigateToEdit()">
            <i class="fas fa-edit me-2"></i>
            Editar
          </button>
          <button class="btn btn-secondary" (click)="navigateBack()">
            <i class="fas fa-arrow-left me-2"></i>
            Voltar
          </button>
        </div>
      </div>

      <!-- Informações Principais -->
      <div class="card mb-4">
        <div class="card-header text-white">
          <h3 class="mb-0">
            <i class="fas fa-info-circle me-2"></i>
            Informações Principais
          </h3>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Nome Fantasia</label>
              <p class="form-control-plaintext">{{ provider.tradeName || 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">Razão Social</label>
              <p class="form-control-plaintext">{{ provider.companyName || 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">CNPJ</label>
              <p class="form-control-plaintext">{{ formatCnpj(provider.cnpj) }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">Telefone</label>
              <p class="form-control-plaintext">{{ formatPhone(provider.phone) }}</p>
            </div>
            <div class="col-md-12" *ngIf="provider.fullAddress">
              <label class="form-label">Endereço Completo</label>
              <p class="form-control-plaintext">{{ provider.fullAddress }}</p>
            </div>
            <div class="col-md-6" *ngIf="provider.contactEmail">
              <label class="form-label">E-mail de Contato</label>
              <p class="form-control-plaintext">
                <a [href]="'mailto:' + provider.contactEmail">{{ provider.contactEmail }}</a>
              </p>
            </div>
            <div class="col-md-6" *ngIf="provider.responsibleName">
              <label class="form-label">Responsável</label>
              <p class="form-control-plaintext">{{ provider.responsibleName }}</p>
            </div>
            <div class="col-md-12" *ngIf="provider.businessHours">
              <label class="form-label">Horário de Funcionamento</label>
              <p class="form-control-plaintext">{{ provider.businessHours }}</p>
            </div>
            <div class="col-md-12" *ngIf="provider.pixKey">
              <label class="form-label">Chave PIX</label>
              <p class="form-control-plaintext">{{ provider.pixKey }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Informações de Serviço -->
      <div class="card mb-4">
        <div class="card-header text-white">
          <h3 class="mb-0">
            <i class="fas fa-cogs me-2"></i>
            Informações de Serviço
          </h3>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-6" *ngIf="provider.serviceType">
              <label class="form-label">Tipo de Serviço</label>
              <p class="form-control-plaintext">
                <span class="service-type-badge" [ngClass]="serviceTypeClass">
                  {{ provider.serviceType }}
                </span>
              </p>
            </div>
            <div class="col-md-6" *ngIf="provider.servedStates">
              <label class="form-label">UFs atendidas</label>
              <p class="form-control-plaintext">{{ provider.servedStates }}</p>
            </div>
            <div class="col-md-12" *ngIf="provider.supportedVehicleTypes">
              <label class="form-label">Tipos de Veículos Suportados</label>
              <p class="form-control-plaintext">{{ provider.supportedVehicleTypes }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Documentos -->
      <div class="card mb-4">
        <div class="card-header text-white">
          <h3 class="mb-0">
            <i class="fas fa-file-upload me-2"></i>
            Documentos ({{ getDocumentsCount() }})
          </h3>
        </div>
        <div class="card-body">
          <div *ngIf="!hasDocumentsWithUrl()" class="alert alert-info">
            <i class="fas fa-info-circle me-2"></i>
            Sem documentos cadastrados.
          </div>
          <div *ngIf="hasDocumentsWithUrl()" class="row g-3">
            <div class="col-12" *ngFor="let doc of getDocumentsWithUrl()">
              <div class="document-item-view">
                <div>
                  <h5>
                    <i class="fas fa-file"></i>
                    {{ doc.documentName || 'Documento' }}
                  </h5>
                  <p class="mb-2">
                    <span class="badge bg-secondary me-2">{{ doc.documentType || 'N/A' }}</span>
                  </p>
                  <div *ngIf="doc.documentUrl" class="mt-2">
                    <a [href]="doc.documentUrl" target="_blank" class="btn btn-sm btn-outline-primary">
                      <i class="fas fa-external-link-alt me-2"></i>
                      Abrir Documento
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Error State -->
    <div *ngIf="!isLoading && !provider" class="error-state">
      <i class="fas fa-exclamation-circle"></i>
      <h3>Erro ao carregar prestador</h3>
      <p>Tente novamente ou volte para a lista.</p>
      <button class="btn btn-primary" (click)="navigateBack()">
        <i class="fas fa-arrow-left"></i>
        Voltar
      </button>
    </div>
  </div>
</app-side-menu>

